import React from 'react';

export interface StartProps {
  fillPercentage?: number;
  size?: number;
  background?: string;
  fill?: string;
}

const Star = (props: StartProps) => {
  const { size, fill, background, fillPercentage = 0 } = props;
  const hashID = Math.random().toString();
  const withFill = `${fillPercentage}%`;

  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="product-review-star"
      >
        <defs>
          <linearGradient id={hashID}>
            <stop offset={withFill} stopColor={fill} />
            <stop stopColor={background} />
          </linearGradient>
        </defs>
        <path
          fill={`url(#${hashID})`}
          d="M10.8582 1.51246C11.2175 0.406889 12.7816 0.406888 13.1408 1.51246L15.0978 7.53557C15.2585 8.02999 15.7192 8.36475 16.2391 8.36475H22.5721C23.7346 8.36475 24.2179 9.85228 23.2775 10.5356L18.1539 14.258C17.7333 14.5636 17.5574 15.1053 17.718 15.5997L19.675 21.6228C20.0342 22.7284 18.7689 23.6477 17.8284 22.9644L12.7049 19.242C12.2843 18.9364 11.7148 18.9364 11.2942 19.242L6.17061 22.9644C5.23015 23.6477 3.96478 22.7284 4.324 21.6228L6.28103 15.5997C6.44168 15.1053 6.26569 14.5636 5.8451 14.258L0.721543 10.5356C-0.218913 9.85229 0.264416 8.36475 1.42688 8.36475H7.75995C8.27982 8.36475 8.74057 8.02999 8.90122 7.53557L10.8582 1.51246Z"
        />
      </svg>
    </>
  );
};

Star.defaultProps = { size: 24, fill: '#FAD70A', background: '#E8E8E8' };

export default Star;
export { Star };
